import {
  createSender,
  createReceiver,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL_WAITINGLIST = 'store/waiting-lists/'

const WAITINGLIST_ADD_URL = prefixAPI('create/', MODEL_WAITINGLIST)
const WAITINGLIST_REMOVE_URL = prefixAPI('delete/', MODEL_WAITINGLIST)
const WAITINGLIST_URL = prefixAPI('list/{?limit,offset}', MODEL_WAITINGLIST)
const WAITINGLIST_IDS = prefixAPI('list-ids/', MODEL_WAITINGLIST)

export const waitingListAddResource = createSender(WAITINGLIST_ADD_URL)
export const waitingListRemoveResource = createSender(WAITINGLIST_REMOVE_URL)
export const waitingListResource = createReceiver(WAITINGLIST_URL)
export const waitingListIdsResource = createReceiver(WAITINGLIST_IDS)
